module.exports = __webpack_public_path__ + "static/media/verify.34843b40.svg";